// Mock data for Noor E Mastan-E-Chaman Trust Website

export const trustInfo = {
  name: "Noor-E-Mastan-E- Chaman Alhaj Hafiz Sayyed Mastan Ali Shah (R.A) Trust.",
  tagline: "Empowering Communities Through Business Excellence",
  description: "A progressive trust dedicated to social welfare and community upliftment through sustainable business ventures. We believe in creating lasting impact by combining entrepreneurship with compassionate service.",
  mission: "To uplift and empower the Muslim community through sustainable business practices, educational initiatives, and comprehensive social welfare programs.",
  vision: "To be a beacon of hope and progress, creating self-sustaining models of community development that inspire generations to come.",
  established: "2022",
  location: "Mumbai, Maharashtra, India",
  email: "info@nooremastan.org",
  phone: "+91 ----- -----",
  address: "123 Community Center, Heritage District, Mumbai - 400001"
};

export const businesses = [
  {
    id: 1,
    name: "Lala Ke Masale",
    description: "State-of-the-art Spices manufacturing facility providing quality Spices and employment opportunities to locals and workers.",
    icon: "factory",
    impact: "11 employees"
  },
  {
     id: 2,
     name: "M B Beverages",
     description: "Best of the class Beverage Brand.",
     icon: "glassWater",
     impact: "World class Beverages."
   },
  // {
  //   id: 3,
  //   name: "Educational Publishing",
  //   description: "Publishing house focusing on educational materials, religious literature, and community resources.",
  //   icon: "book-open",
  //   impact: "500K+ books distributed"
  // },
  // {
  //   id: 4,
  //   name: "Healthcare Services",
  //   description: "Affordable healthcare clinics providing quality medical services to underserved communities.",
  //   icon: "heart-pulse",
  //   impact: "10K+ patients annually"
  // },
  // {
  //   id: 5,
  //   name: "Skill Development Center",
  //   description: "Vocational training and skill development programs empowering youth with market-ready skills.",
  //   icon: "graduation-cap",
  //   impact: "1000+ trained annually"
  // },
  /*{
    id: 6,
    name: "Real Estate Development",
    description: "Affordable housing projects and commercial spaces supporting community infrastructure.",
    icon: "building",
    impact: "500+ families housed"
  }*/
];

export const socialPrograms = [
  {
    id: 1,
    title: "Education Support",
    description: "Scholarships, school supplies, and educational resources for underprivileged children.",
    // beneficiaries: "",
    image: "education"
  },
  {
    id: 2,
    title: "Healthcare Initiatives",
    description: "Free medical camps, health awareness programs, and subsidized treatments.",
    beneficiaries: "",
    image: "healthcare"
  },
  // {
  //   id: 3,
  //   title: "Women Empowerment",
  //   description: "Skill training, microfinance support, and entrepreneurship programs for women.",
  //   beneficiaries: "3000+ women",
  //   image: "empowerment"
  // },
  // {
  //   id: 4,
  //   title: "Elder Care",
  //   description: "Support services, healthcare assistance, and community programs for senior citizens.",
  //   beneficiaries: "2000+ elders",
  //   image: "eldercare"
  // },
  {
    id: 5,
    title: "Orphan Support",
    description: "Comprehensive care including education, healthcare, and emotional support for orphans.",
    //beneficiaries: "800+ children",
    image: "orphan"
  },
  // {
  //   id: 6,
  //   title: "Community Development",
  //   description: "Infrastructure projects, clean water initiatives, and neighborhood improvement programs.",
  //   beneficiaries: "",
  //   image: "community"
  // }
];

export const events = [
  {
    id: 1,
    title: "Annual Community Gathering",
    date: "2024-03-15",
    time: "10:00 AM",
    location: "Main Trust Campus",
    description: "Join us for our annual celebration bringing together community members, partners, and well-wishers.",
    type: "gathering"
  },
  {
    id: 2,
    title: "Health & Wellness Camp",
    date: "2024-04-20",
    time: "9:00 AM",
    location: "Community Health Center",
    description: "Free health checkups, consultations, and wellness guidance for all community members.",
    type: "healthcare"
  },
  {
    id: 3,
    title: "Daily Langer",
    date: "Every day",
    time: "12:00 to 08:00",
    location: "Training Center",
    description: "Daily Langer for each and everyone.",
    type: "Langer"
  },
  {
    id: 4,
    title: "Iftar Community Dinner",
    date: "2024-06-05",
    time: "6:30 PM",
    location: "Trust Grounds",
    description: "Community iftar bringing together families for breaking fast during Ramadan.",
    type: "religious"
  }
];

export const gallery = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1600383963284-91ef78fc9b6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxJc2xhbWljJTIwYXJjaGl0ZWN0dXJlJTIwbW9zcXVlfGVufDB8fHx8MTc2ODc5ODgyMHww&ixlib=rb-4.1.0&q=85",
    title: "Trust Headquarters",
    category: "architecture"
  },
  {
    id: 2,
    url: "https://res.cloudinary.com/db6zl4j0y/image/upload/v1769462063/WhatsApp_Image_2026-01-23_at_11.27.18_n8nlkz.jpg",
    title: "Masjid DP Plan",
    category: "architecture"
  },
  {
    id: 3,
    url: "https://res.cloudinary.com/db6zl4j0y/image/upload/v1775754338/Langer_Details_Photo._orw7bm.jpg",
    title: "Daily Langer",
    category: "social-work"
  },
  {
    id: 4,
    url: "https://res.cloudinary.com/db6zl4j0y/image/upload/v1769462975/s_flhjtn.jpg",
    title: "Mazar E Sharrif DP Plan",
    category: "architecture"
  },
  {
    id: 5,
    url: "https://res.cloudinary.com/db6zl4j0y/image/upload/v1769625004/kolkata-india-07th-apr-2023-muslim-volunteers-are-distributing-special-drinks-before-breaking-their-fasting-and-have-iftar-meal-together-during-the-holy-month-of-ramadan-at-the-nakhoda-masjid-in-kolk_ofnghy.jpg",
    title: "Volunteer Activities",
    category: "social-work"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1612164617328-df5179f61327?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxJc2xhbWljJTIwYXJjaGl0ZWN0dXJlJTIwbW9zcXVlfGVufDB8fHx8MTc2ODc5ODgyMHww&ixlib=rb-4.1.0&q=85",
    title: "Heritage Building",
    category: "architecture"
  },
  {
    id: 7,
    url: "https://res.cloudinary.com/db6zl4j0y/image/upload/v1769624679/Cultural_Event._t2c6x3.webp",
    title: "Cultural Gathering",
    category: "events"
  },
  {
    id: 8,
    url: "https://res.cloudinary.com/db6zl4j0y/image/upload/v1769624419/langar3_vf7ctt.jpg",
    title: "Langer Sharife",
    category: "events"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Khan",
    role: "Beneficiary - Education Program",
    text: "The trust's scholarship program changed my life. Today, I'm a software engineer supporting my family.",
    rating: 5
  },
  {
    id: 2,
    name: "Fatima Begum",
    role: "Women's Empowerment Program",
    text: "Through their skill training program, I started my own tailoring business. Now I'm financially independent.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Ibrahim Ali",
    role: "Healthcare Partner",
    text: "Working with this trust has shown me true community service. Their impact is remarkable and sustained.",
    rating: 5
  },
  {
    id: 4,
    name: "Rashid Mohammed",
    role: "Business Employee",
    text: "I've been working at their textile unit for 5 years. Fair wages, respect, and growth opportunities.",
    rating: 5
  }
];

export const stats = [
  {
    id: 1,
    value: "50,000+",
    label: "Lives Impacted",
    icon: "users"
  },
  {
    id: 2,
    value: "6",
    label: "Business Ventures",
    icon: "briefcase"
  },
  {
    id: 3,
    value: "15+",
    label: "Years of Service",
    icon: "calendar"
  },
  {
    id: 4,
    value: "25+",
    label: "Community Programs",
    icon: "heart"
  }
];

export const team = [
  {
    id: 1,
    name: "Maulana Abdul Rahman",
    role: "Chairman",
    bio: "Leading the trust with vision and dedication for over 15 years."
  },
  {
    id: 2,
    name: "Mrs. Zainab Khatoon",
    role: "Social Welfare Director",
    bio: "Pioneering women empowerment and education initiatives."
  },
  {
    id: 3,
    name: "Mr. Salman Qureshi",
    role: "Business Operations Head",
    bio: "Managing business ventures for sustainable social impact."
  },
  {
    id: 4,
    name: "Dr. Aisha Siddiqui",
    role: "Healthcare Director",
    bio: "Overseeing healthcare programs and medical initiatives."
  }
];
